export default "__VITE_ASSET__394b54ee__"